import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import Chip from '@/components/ui/Chip.tsx';
import { AcceptanceDocumentVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import {
  isDocumentRecommended,
  isDocumentSelected,
} from './acceptanceDocuments.ts';

interface AcceptanceDocumentRowProps
  extends Omit<React.LabelHTMLAttributes<HTMLLabelElement>, 'onToggle'> {
  document: AcceptanceDocumentVm;
  selectedIds: string[];
  onToggle: (document: AcceptanceDocumentVm) => void;
}

/**
 * Wiersz dokumentu: pole wyboru, nazwa i odznaka. Zaznaczyć i odznaczyć da się
 * każdy — paczka może pójść bez ani jednego podpisu.
 */
const AcceptanceDocumentRow = ({
  document,
  selectedIds,
  onToggle,
  className,
  ...props
}: AcceptanceDocumentRowProps) => {
  const isSelected = isDocumentSelected(document, selectedIds);

  return (
    <label
      className={cn(
        'flex cursor-pointer items-start gap-[11px] py-2.5',
        className,
      )}
      {...props}
    >
      <input
        type="checkbox"
        className="peer sr-only"
        checked={isSelected}
        onChange={() => onToggle(document)}
      />
      <span
        aria-hidden
        className={cn(
          'mt-px box-border flex size-[19px] shrink-0 items-center justify-center rounded-md border peer-focus-visible:ring-2 peer-focus-visible:ring-accent-600',
          isSelected
            ? 'border-ink bg-ink text-basic-white'
            : 'border-neutral-300 bg-basic-white text-transparent',
        )}
      >
        <Check className="size-3 stroke-[3.5]" />
      </span>

      <span
        className={cn(
          'min-w-0 text-[15px] font-semibold',
          isSelected ? 'text-ink' : 'text-neutral-500',
        )}
      >
        {document.name}
      </span>

      {isDocumentRecommended(document) && (
        <Chip
          label="zalecany"
          tone="accent"
          fill="soft"
          className="ml-auto shrink-0"
        />
      )}
    </label>
  );
};

export default AcceptanceDocumentRow;
